import { useState } from "react";
import { Search } from "lucide-react";
import { useApi } from "@/lib/api";
import { EventCard } from "@/components/EventCard";
import { Page, Spinner, Empty } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const DISTANCES = ["5", "10", "25", "50", "100"];

export default function Discover() {
  const [zip, setZip] = useState("");
  const [appliedZip, setAppliedZip] = useState("");
  const [distance, setDistance] = useState("25");
  const [q, setQ] = useState("");
  const params = new URLSearchParams({ limit: "60", distance });
  if (appliedZip) params.set("zip", appliedZip);
  const { data, isLoading, error } = useApi(`/public/events?${params}`);
  const events = (data?.events || []).filter((e) => !q || `${e.title} ${e.location_name} ${e.creator?.name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <Page>
      <p className="font-mono text-xs uppercase tracking-widest text-stone-500">Discover</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Events near you</h1>

      <div className="mt-8 flex flex-col lg:flex-row gap-3 p-3 rounded-3xl bg-white border border-stone-200">
        <div className="relative flex-1">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
          <Input data-testid="filter-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search events, places, creators" className="pl-10 h-11 rounded-2xl border-0 bg-stone-100" />
        </div>
        <form className="flex gap-2 sm:gap-3" onSubmit={(e) => { e.preventDefault(); setAppliedZip(zip.trim()); }}>
          <Input data-testid="filter-zip-input" value={zip} onChange={(e) => setZip(e.target.value)} placeholder="ZIP" inputMode="numeric" className="h-11 flex-1 lg:w-28 rounded-2xl border-0 bg-stone-100 font-mono" />
          <Select value={distance} onValueChange={setDistance}>
            <SelectTrigger data-testid="filter-distance-select" className="h-11 w-28 rounded-2xl border-0 bg-stone-100"><SelectValue /></SelectTrigger>
            <SelectContent>{DISTANCES.map((d) => <SelectItem key={d} value={d} data-testid={`filter-distance-${d}`}>{d} mi</SelectItem>)}</SelectContent>
          </Select>
          <button data-testid="filter-apply-btn" className="h-11 px-5 rounded-2xl bg-stone-900 text-white text-sm font-semibold hover:bg-[#FF5C00] transition-colors">Apply</button>
        </form>
      </div>

      <div className="mt-10">
        {isLoading ? <Spinner /> : error ? <Empty title="Couldn't load events">Try again in a moment.</Empty> : events.length === 0 ? (
          <Empty title="No events found">Try a bigger distance or another ZIP code.</Empty>
        ) : (
          <>
            <p data-testid="discover-count" className="mb-5 font-mono text-xs text-stone-500">{events.length} events</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">{events.map((e, i) => <EventCard key={e.id} event={e} index={i} />)}</div>
          </>
        )}
      </div>
    </Page>
  );
}
